import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Icon } from 'components/chroma';
import { TextSmall } from 'components/chroma/extended';

import THEME from 'theme';

const DiscountContainer = styled.div`
  display: flex;
  align-items: center;
  .c-icon {
    color: ${THEME.TICK_ICON.VALID};
  }
`;

const StyledIconWrapper = styled.div<{ alignTop?: boolean }>`
  flex-shrink: 0;
  align-self: ${({ alignTop }) => (alignTop ? 'flex-start' : 'auto')}};
`;

export const TickedDiscountItem: FunctionComponent<{
  campaignDescription: string;
  suppressOfferApplied?: boolean;
}> = ({ campaignDescription, suppressOfferApplied }) => (
  <DiscountContainer>
    <StyledIconWrapper alignTop={suppressOfferApplied}>
      <Icon name="checkCircle" margin={{ right: 2 }} />
    </StyledIconWrapper>
    <TextSmall margin={{ bottom: 0 }}>{campaignDescription}</TextSmall>
  </DiscountContainer>
);
